import axios from 'axios';
import { API_BASE_URL } from './config';

const api = axios.create({
  baseURL: API_BASE_URL,
});

// ── Login expiry (Move 5) ────────────────────────────────────────────────
// Logins last 7 days. When one runs out the server answers 401, but the site
// used to keep showing the user as logged in and every action failed with
// "Invalid token". Now an expired or rejected login is cleared and the user
// is sent to the login page, then back to where they were.
function safeGet(key) { try { return localStorage.getItem(key); } catch { return null; } }
function safeRemove(key) { try { localStorage.removeItem(key); } catch { /* ignore */ } }

export function isTokenExpired(token) {
  if (!token) return true;
  try {
    const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    return typeof payload.exp === 'number' && payload.exp * 1000 <= Date.now();
  } catch {
    return true;
  }
}

export function clearLogin() {
  safeRemove('token');
  safeRemove('user');
}

function sendToLogin() {
  clearLogin();
  if (window.location.pathname !== '/auth') {
    const back = window.location.pathname + window.location.search;
    window.location.assign(`/auth?expired=1&next=${encodeURIComponent(back)}`);
  }
}

api.interceptors.request.use(config => {
  const token = safeGet('token');
  if (token && isTokenExpired(token)) {
    sendToLogin();
    return Promise.reject(new axios.Cancel('Login expired'));
  }
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    const status = err.response?.status;
    const message = err.response?.data?.error || '';
    if (status === 401 && safeGet('token') && /token/i.test(message)) sendToLogin();
    return Promise.reject(err);
  }
);

export default api;
